import { useLayoutEffect, useState } from 'react';
import debounce from 'lodash.debounce';

const BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 1230,
  DESKTOP: 1440,
} as const;

type ScreenSize = {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
};

const useScreenSize = (): ScreenSize => {
  const [windowSize, setWindowSize] = useState(window.innerWidth);

  useLayoutEffect(() => {
    const updateSize = (): void => {
      setWindowSize(window.innerWidth);
    };
    window.addEventListener('resize', debounce(updateSize, 250));

    return (): void => window.removeEventListener('resize', updateSize);
  }, []);

  return {
    isMobile: windowSize <= BREAKPOINTS.MOBILE,
    isTablet: windowSize <= BREAKPOINTS.TABLET,
    isDesktop: windowSize > BREAKPOINTS.TABLET,
  };
};

export default useScreenSize;
